import React, { createContext, useContext } from "react";
import "react-toastify/dist/ReactToastify.min.css";
import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import { ToastContainer, toast } from "react-toastify";
import { ToastComponent, NotifyType } from "./Toast";

if (typeof window !== "undefined") {
  LogRocket.init("xc3wci/refferal");
  // plugins should also only be initialized when in the browser
  setupLogRocketReact(LogRocket);
}

const AppContext = createContext<{
  notify: (
    message: string,
    type: NotifyType,
    position?: string,
    headline?: string,
    autoClose?: boolean
  ) => void;
}>({
  notify: () => null,
});

export const AppProvider = ({ children }: any) => {
  const notify = (
    message: string,
    type: NotifyType,
    position?: any,
    headline?: string,
    autoClose: boolean = false
  ) => {
    toast(
      <ToastComponent message={message} headline={headline} type={type} />,
      {
        position: position ? position : "top-right",
        autoClose: autoClose ? false : 3000,
        className: `${type}_class`,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,

        draggable: true,
        progress: undefined,
      }
    );
  };
  return (
    <AppContext.Provider value={{ notify }}>
      <ToastContainer />
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  return useContext(AppContext);
};
